import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import { HuchaCardBackground } from '../../ui/hucha-card-background';
import { HuchaStandardCardC2 } from './hucha-standard-card-c2';
import { HuchaStandardCardC3 } from './hucha-standard-card-c3';
import { HuchaStandardCardC1 } from './hucha-standard-card-c1';

const StandardHuchaCardContainer = styled.div`
	display: flex;
	flex-direction: column;

	gap: var(--size-dynamic0250);

	@media (min-width: 560px) {
		flex-direction: row;
		justify-content: center;
		align-items: center;

		& > div[data-testid='c1-container'] {
			flex: 0 1 445px;
		}
		& > div[data-testid='c2-container'] {
			flex: 0 1 400px;
		}
		& > div[data-testid='c3-container'] {
			flex: 0 0 auto;
		}

		/* clase que se aplica cuando supera el ancho límite */
		&.small-hucha-layout {
			flex-wrap: wrap;
			gap: var(--size-dynamic0200);
			& > div[data-testid='c1-container'] {
				flex: 1;
			}
			& > div[data-testid='c2-container'] {
				flex: 1;
			}
		}
	}
`;

export const HuchaStandardCard = ({ huchaValues }: { huchaValues: HuchaVentaValues }) => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const [isSmallHuchaLayout, setIsSmallHuchaLayout] = useState(false);
	const WIDTH_LIMIT = 880;

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;

		const updateWidthState = () => {
			setIsSmallHuchaLayout(el.offsetWidth <= WIDTH_LIMIT);
		};

		updateWidthState();

		let observer: ResizeObserver | undefined;
		if (typeof ResizeObserver !== 'undefined') {
			observer = new ResizeObserver(updateWidthState);
			observer.observe(el);
		}

		window.addEventListener('resize', updateWidthState);

		return () => {
			observer?.disconnect();
			window.removeEventListener('resize', updateWidthState);
		};
	}, []);

	return (
		<HuchaCardBackground stretchContent data-testid="hucha-venta-card-container" wrap={'never'}>
			<StandardHuchaCardContainer ref={containerRef} className={isSmallHuchaLayout ? 'small-hucha-layout' : ''}>
				<HuchaStandardCardC1 huchaValues={huchaValues} isSmallHuchaLayout={isSmallHuchaLayout} />
				<HuchaStandardCardC2 dineroHucha={huchaValues?.dineroHucha || '0'} />
				{!isSmallHuchaLayout && <HuchaStandardCardC3 huchaValues={huchaValues} />}
			</StandardHuchaCardContainer>
		</HuchaCardBackground>
	);
};
